import { useEffect } from "react";
import {
    handlePushSubscription,
    requestNotificationPermission,
} from "../utils/pushUtils";
import { PWAUtils } from "../utils/PWAUtils";

const usePushNotificationPermission = (
    uuid: string | undefined,
    vapidKey: string
) => {
    useEffect(() => {
        console.log("Checking push subscription");
        if (
            !uuid ||
            typeof Notification === "undefined" ||
            (PWAUtils.isAppleMobile() && !PWAUtils.isStandalone()) // || Notification.permission === "granted"
        ) {
            return; // Don't request if browser doesn't support notifications
        }

        const askForPermission = async () => {
            switch (Notification.permission) {
                case "default":
                    console.log("Requesting notification permissions...");
                    await requestNotificationPermission(uuid, vapidKey);
                    break;

                case "granted":
                    console.log("Validating push subscription...");
                    await handlePushSubscription(uuid, vapidKey);
                    break;

                case "denied":
                    console.warn(
                        "Notifications are blocked by the user. Consider showing a banner for re-enabling."
                    );
                    break;
            }
        };

        askForPermission();
    });
};

export default usePushNotificationPermission;
